import { createContext, useContext } from 'react';
import type { CanvasInteractionController } from './useCanvasInteraction';

const Ctx = createContext<CanvasInteractionController | null>(null);

export const CanvasInteractionProvider = Ctx.Provider;

/** Access to the canvas gesture controller from inside the canvas tree (handles, overlays). */
export const useCanvasInteractionController = (): CanvasInteractionController => {
  const value = useContext(Ctx);
  if (!value) throw new Error('useCanvasInteractionController must be used inside SpatialCanvas');
  return value;
};
